<template>
  <div>
    <table
      :class="[
        hideHeader ? '' : 'show-header',
        hideFooter ? '' : 'show-footer',
      ]"
    >
      <thead v-if="!hideHeader">
        <tr>
          <td>
            <div class="header-space">&nbsp;</div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <slot></slot>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="!hideFooter">
        <tr>
          <td>
            <div class="footer-space">&nbsp;</div>
          </td>
        </tr>
      </tfoot>
    </table>

    <div v-if="!hideHeader" class="header">
      <slot name="header"></slot>
    </div>
    <div v-if="!hideFooter" class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrintPage",

  props: {
    hideHeader: { type: Boolean, default: false },
    hideFooter: { type: Boolean, default: false },
  },
};
</script>

<style>
table {
  width: 100%;
}

table.show-header {
  margin-top: 100px;
}

table.show-footer {
  margin-bottom: 100px;
}

.header,
.footer {
  width: 100%;
  position: absolute;
}

.header {
  top: 0;
}

.footer {
  bottom: 0;
}

@media print {
  table.show-header {
    margin-top: 0;
  }

  table.show-footer {
    margin-bottom: 0;
  }

  .header,
  .header-space,
  .footer,
  .footer-space {
    height: 100px;
  }

  .header,
  .footer {
    position: fixed;
  }
}
</style>